import React, {useEffect, useState} from 'react';
import { Button, TextField } from '@mui/material';
import '../styles/all-blogs-page.css';
import BlogsGrid from '../components/BlogsGrid';
import { getBlogs } from '../services/API/BlogpostAPI';
import { useSearchParams } from 'react-router-dom';
import { useMemo } from 'react';
import useAsyncCallWithLoader from '../hooks/useAPICallWithLoader';
import ConfirmDialog from '../components/ConfirmDialog';
import { postSubscriber } from '../services/API/SubscriberAPI';
import useShowNotification from '../hooks/useShowNotification';

const AllBlogsPage = () => {
  return (
    <div>
      <TitleScreen/>
      <BlogsScreen/>
    </div>
  )
}

const TitleScreen = () => {
  return (
    <div className='all-blogs-page__background-image'>
      <div className='all-blogs-page__title-container'>
        <h1 className='all-blogs-page__title title'>Blogs</h1>
        <p className='all-blogs-page__undertitle text'>Alle verhalen over onze tripjes in het buitenland</p>
      </div>
    </div>
  )
}

const BlogsScreen = () => {
  const [searchParams] = useSearchParams();

  const initialInputText = useMemo(() => {
    return searchParams.get("search");
  }, [searchParams])

  const [inputText, setInputText] = useState(initialInputText ? initialInputText : "");
  const [blogsData, setBlogsData] = useState(null);
  const [filteredBlogs, setFilteredBlogs] = useState(null);
  const [subscriptionDialogOpen, setSubscriptionDialogOpen] = useState(false);
  
  useEffect(() => {
    const fetchData = async () => {
      const data = await getBlogs();
      setBlogsData(data);
    }
    fetchData();
  }, [])

  useEffect(() => {
    if (blogsData) {
      setFilteredBlogs(blogsData.filter((blogObject) => {
        if (inputText === "") {
            return true;
        }
        //return the item which contains the user input
        else {
          return blogObject.country.toLowerCase().includes(inputText.toLowerCase()) || 
            blogObject.title.toLowerCase().includes(inputText.toLowerCase())
        }
      }));
    }
  }, [blogsData, inputText])

  return (
    <div className='all-blogs-page__all-blogs-section'>
      <div className='all-blogs-page__search-section'>
        <div className='all-blogs-page__hidden-button'>
          <Button>Blog melding?</Button>
        </div>
        <div className='all-blogs-page__search-bar'>
          <TextField
            variant="outlined"
            value={inputText}
            onChange={(e) => setInputText(e.target.value)}
            placeholder='Zoeken...'
            fullWidth={true}
          />
        </div>
        <div className='all-blogs-page__blog-reminder'>
          <Button
            variant='text'
            onClick={() => setSubscriptionDialogOpen(true)}
          >
            Blog melding?
          </Button>
        </div>
      </div>
      <BlogsGrid
        blogsObjectArray={filteredBlogs}
      />
      <SubscriptionDialog
        subscriptionDialogOpen={subscriptionDialogOpen}
        setSubscriptionDialogOpen={setSubscriptionDialogOpen}
      />
    </div>
  )
}

const SubscriptionDialog = ({
  subscriptionDialogOpen, 
  setSubscriptionDialogOpen,
}) => {
  const [email, setEmail] = useState("");
  const { showSuccessNotification, showErrorNotification } = useShowNotification();

  const onCancel = () => setSubscriptionDialogOpen(false)

  const onSubmitClick = useAsyncCallWithLoader(async () => {
    // createDirectory call
    const subscriberResponse = await postSubscriber(email);

    if (subscriberResponse.status === 201) {
      showSuccessNotification("Gelukt! Een bevestigingsmailtje is onderweg.");
    }
    else {
      showErrorNotification("Oeps, hier is iets mis gegaan. Probeer later opnieuw.");
    }
  });

  return (
    <ConfirmDialog
      title="Melding voor blogpost?"
      body={
        <>
          <p>Wil je graag een melding op de mail ontvangen als er een nieuwe blog is? Vul dan hieronder je email adres in:</p>
          <TextField
            id="email" 
            label="Email"
            type="text"
            value={email} 
            variant='standard'
            fullWidth
            autoFocus
            InputLabelProps={{
              shrink: true,
            }}
            onChange={(e) => setEmail(e.target.value)} 
          />
          <p>Je ontvangt een mailtje als bevestiging dat je bent toegevoegd.</p>
        </>
      }
      onCancel={onCancel}
      onSubmit={onSubmitClick}
      open={subscriptionDialogOpen}
      setOpen={setSubscriptionDialogOpen}
    />
  )
}

export default AllBlogsPage
